import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {
				all_m: [1, 2],
			},
			ads: {
				home_1: { class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-6466344935166719', 'data-ad-slot': '1437846030', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				home_2: { class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-6466344935166719', 'data-ad-slot': '9124764368', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				home_3: { class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-6466344935166719', 'data-ad-slot': '7811682692', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				home_4: { class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-6466344935166719', 'data-ad-slot': '8119638609', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },

				all: [
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-6466344935166719', 'data-ad-slot': '2898331000', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
					{ class: 'adsbygoogle', style: 'display:block', 'data-ad-client': 'ca-pub-6466344935166719', 'data-ad-slot': '3549838207', 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' },
				],
			},

			adsensConfig: {},
			domainConfig: null,
			nodeMovieList: [],
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_MOVIE_LIST(state, movies) {
				state.nodeMovieList = movies
			},
			SET_MOVIE_LIST_REV(state, movies) {
				state.movieListRev = movies
			},
			SET_MOVIE_CURRENT(state, movie) {
				state.movieCurrent = movie
			},
			SET_PAGE(state, page) {
				state.page = page
			},
			setMovieData(state, movieData) {
				console.log('122312232131223')
				state.nodeMovieList = movieData.movies
			},
		},
		actions: {
			updateMovieList({ commit }, movies) {
				commit('SET_MOVIE_LIST', movies)
				commit('SET_MOVIE_LIST_REV', [...movies].reverse())
			},
			updateCurrentMovie({ commit }, movie) {
				commit('SET_MOVIE_CURRENT', movie)
			},
			updatePage({ commit }, page) {
				commit('SET_PAGE', page)
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			nodeMovieList: (state) => state.nodeMovieList,
		},
	})
}
